import { defineComponent, h } from 'vue';

const CAlertLink = defineComponent({
    name: 'CAlertLink',
    setup(_, { slots }) {
        return () => h('a', {
            class: 'alert-link',
        }, slots);
    },
});

export { CAlertLink };
//# sourceMappingURL=CAlertLink.js.map
